import React from 'react'

import styles from './styles.module.scss'

import { ReactComponent as StatusIcon } from './icons/status.svg'
import UseSmartTooltip from '../../hooks/useSmartTooltip'

const PersonalStatus = ({ status }) => {
  return (
    <>
      <div className={styles.statusWrapper}>
        <StatusIcon />

        <span className={styles.status}>{status}</span>
      </div>
    </>
  )
}

export default PersonalStatus
